import { Grid, Typography, Button } from "@mui/material";
import colors from "../../../../colors";
import Lottie from "lottie-react";
import noTransactionsAnimation from '../../../../../icons/lottieAnimations/noTransactions.json'
import React from "react";
import { texts } from "../../../../general/texts";
import { useNavigate } from "react-router-dom";

const EmptyTransactionHistory = () => {

  const navigate = useNavigate()

  return (
    <Grid container justifyContent={"center"}>
      <Grid container item md={4} xs={6} justifyContent={"center"}>
        <Lottie
          animationData={noTransactionsAnimation}
          loop={true}
          autoplay={true}
        />
      </Grid>
      <Grid container item md={12} xs={12} justifyContent={"center"}>
        <Typography
          sx={{
            fontFamily: "GerberaBold",
            textTransform: "none",
            color: colors.darkBlue,
          }}
          pb={"7%"}
        >
          {texts["message-no-transaction"]}
        </Typography>
      </Grid>
      <Grid
        container
        item
        md={9}
        xs={9}
        justifyContent={"center"}
        pt={5}
        onClick={() => {
          navigate("/onpayments");
        }}
      >
        <Button
          sx={{
            backgroundColor: "#365472",
            color: colors.white,
            fontFamily: "GerberaBold",
            width: "200px",
            borderRadius: "8px",
            textTransform: "none",
            ":hover": { background: colors.darkBlue },
          }}
        >
          {texts["prompt-start-now"]}
        </Button>
      </Grid>
    </Grid>
  );
};

export default EmptyTransactionHistory;
